import axios from "axios";

const API_URL =
"https://vortexnetowrknew.co.uk/php-backend/accountLinks.php";

export async function getAccountLinks(username) {
const response = await axios.get(API_URL, {
params: {
username,
},
});

return response.data;
}

export async function saveAccountLinks(username, accounts) {
const response = await axios.post(API_URL, {
username,
discord: accounts.discord,
youtube: accounts.youtube,
website: accounts.website,
});

return response.data;
}
